module.exports = __webpack_public_path__ + "static/img/pergunta-por-canais.082e716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pergunta-por-canais.png
// module id = Gp25
// module chunks = 1